import AlertTemplate from './Alert.vue'

export default {
  install (Vue) {
    let constructor = null
    let instance = null

    Vue.prototype.$alert = function () {}

    Vue.prototype.$alert.show = function (options) {
      constructor = options.template ? Vue.extend(options.template) : Vue.extend(AlertTemplate)

      if (instance) {
        instance.isShow = true
        instance.message = options.message
        instance.data = options.data
        instance.$emit('alert:open')
        return instance
      }

      instance = new constructor({
        el: document.createElement('div'),
        data () {
          return {
            isShow: true,
            title: options.title,
            message: options.message,
            data: options.data
          }
        },
        mounted () {
          this.$nextTick(() => {
            this.$emit('alert:open')
          })
        }
      })

      document.body.appendChild(instance.$el)

      return instance
    }

    Vue.prototype.$alert.close = function () {
      if (instance) {
        instance.isShow = false
      }

      constructor = null
      instance = null
    }
  }
}
